import React, { useState, useEffect } from "react";
import { useSite } from "@/context/SiteContext";
import { Megaphone, ArrowRight } from "lucide-react";

export default function AnnouncementBar() {
  const site = useSite();
  const a = (site && site.announcement) || {};
  const items = (a && a.items) || [];
  // Admin-controlled speed = seconds for one line to cross. Higher = slower. 0 = paused.
  const spd = (a.speed_seconds ?? a.speed);
  const spdNum = spd !== undefined && spd !== null && spd !== "" ? Number(spd) : 40;
  const dur = Math.max(3, spdNum);
  const paused = spdNum <= 0;

  const [idx, setIdx] = useState(0);
  // Rotate to the next line each time the current line finishes crossing.
  useEffect(() => {
    if (paused || items.length <= 1) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), dur * 1000);
    return () => clearInterval(t);
  }, [paused, items.length, dur]);

  if (!a.enabled || items.length === 0) {
    // While the site bootstrap is still loading we don't yet know the announcement
    // config. Reserve the bar's height (40px) so the header/hero/footer below do not
    // shift down when the real bar mounts (primary desktop CLS fix).
    if (site && site.loading) {
      return <div style={{ height: 40, background: "var(--yellow)" }} aria-hidden="true" data-testid="announcement-placeholder" />;
    }
    return null;
  }
  const current = items[idx % items.length];
  const marqueeStyle = paused ? { animationPlayState: "paused" } : { animationDuration: `${dur}s` };

  return (
    <div className="w-full" style={{ background: "var(--yellow)" }} data-testid="announcement-bar">
      <div className="relative flex items-stretch overflow-hidden" style={{ height: 40 }}>
        <div className="flex items-center gap-2 shrink-0 pl-3 sm:pl-4 pr-3 h-full z-10" style={{ background: "var(--yellow-dark)" }}>
          <Megaphone size={15} style={{ color: "var(--brand-primary)" }} />
          <span className="text-xs font-bold tracking-wide" style={{ color: "var(--brand-primary)" }}>NEWS</span>
        </div>
        <div className="flex-1 relative overflow-hidden">
          {/* Only ONE line scrolls at a time, left -> right, then the next line restarts from the left */}
          <a
            key={idx}
            href={current.link || "#"}
            className="ekta-ticker-one text-xs sm:text-sm font-bold tracking-wide gap-2"
            style={{ color: "var(--brand-primary)", ...marqueeStyle }}
            data-testid="announcement-line"
          >
            {current.text}<ArrowRight size={13} />
          </a>
        </div>
      </div>
    </div>
  );
}
